import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/inbox/")({
	beforeLoad: () => {
		throw redirect({
			to: "/dashboard/inbox/alerts",
			replace: true,
		});
	},
});
